import { SearchField, SearchFieldProps } from "@synota-io/synota-shared-ui";
import {
  IServiceChargeCounterparty,
  useServiceChargeCounterparties,
} from "../../api/hooks/useServiceChargeCounterparties";

type Props = {
  uuid: string;
};

export type DashboardCounterpartySearchOption =
  | (IServiceChargeCounterparty & {
      label: string;
      value: string;
    })
  | null;

export type DashboardCounterpartySearchFieldProps = Omit<SearchFieldProps, "options"> & Props;

export const DashboardCounterpartySearchField = ({
  uuid,
  ...props
}: DashboardCounterpartySearchFieldProps) => {
  const { counterparties, isLoading: isLoadingProviders } = useServiceChargeCounterparties({
    user_uuid: uuid,
  });

  const optionProps: Pick<SearchFieldProps, "options" | "loading"> = {
    loading: isLoadingProviders,
    options: counterparties.map((c) => ({ ...c, value: c.email, label: c.name || c.email })),
  };

  return (
    <SearchField
      label="Search Counterparty"
      getOptionKey={(option) => (typeof option === "string" ? option : option.value + option.label)}
      {...optionProps}
      {...props}
    />
  );
};
